import React from 'react';

const PlayerSection = () => {
    return (
        <div>
            <p>
                We can play, go back, as well as skip a song. The library contains a list of all songs
            </p>
        </div>
    )
}
export default PlayerSection;